import React from 'react';

import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import toast from 'react-hot-toast';

import useToken from 'hooks/useToken';
import PrivateLayout from "layouts/private";
import createCapitalEntryValidation from 'formValidations/createCapitalEntry';
import FormContainer from 'components/FormContainer';
import { defaultError } from 'utils/message';
import CapitalEntryForm from 'components/forms/CapitalEntryForm';
import { createCapitalEntry } from 'apiRequest/capital-entries';
import { fetchCapital } from 'apiRequest/capitals';
import { Box, Breadcrumbs, Container, Link } from '@mui/material';

export default function CapitalEntryCreate() {
  const navigate = useNavigate();

  const { id } = useParams();

  const { token } = useToken();

  const { data: capital, isLoading, isError, error } = useQuery("capital-fetchCapital", () => {
    return fetchCapital({
      token,
      id,
      params: {
        partials: [
          'account',
        ]
      }
    });
  });




  const mutation = useMutation(data => {
    return createCapitalEntry({ token, data });
  });

  const handleOnSubmit = async ({ values: data }) => {
    const submitData = {
      capital_id: id,
      ...data
    };

    mutation.mutate(submitData, {
      onSuccess: () => {
        navigate(`/capitals/${id}/entries`, { replace: true });
      },
      onError: (error) => {
        if (error.response?.status !== 422) {
          toast.error(error.message || defaultError);
          console.error(error);
        }
      }
    });
  };


  return (
    <PrivateLayout>
      <Container maxWidth="md">
        <Box sx={{ mb: 2 }} textAlign={"right"}>
          <Link component={RouterLink} to={`/capitals/${id}/entries`}>Go back to Entries</Link>
        </Box>
      </Container>
      <FormContainer
        title="Capital Entry"
        subheader={`Account: ${capital?.data.data.account.name} | crrency: ${capital?.data.data.figure.code}`}
        onSubmit={handleOnSubmit}
        validationSchema={createCapitalEntryValidation}
        serverError={mutation.error}
      >
        <CapitalEntryForm
          capitalId={id}
          loading={mutation.isLoading}
        />
      </FormContainer>
    </PrivateLayout>
  );
};
